import { Button, StatusMessage } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';

import { SearchX } from 'lucide-react';

/**
 * The record genuinely does not exist.
 *
 * Distinct from {@link AccessDeniedState} on purpose: telling someone their
 * colleague's record "does not exist" when they simply lack access is a
 * correctness bug, not a copy nit.
 */
function NotFoundState({ onBack }) {
  const { t } = useTranslation('unified-profiles');

  return (
    <div data-testid="not-found-state" className="flex flex-1 flex-col items-center justify-center gap-6">
      <StatusMessage
        icon={SearchX}
        title={t('states.notFound.title')}
        subtitle={t('states.notFound.subtitle')}
      />
      {onBack ? (
        <Button variant="secondary" size="medium" onClick={onBack}>
          {t('states.notFound.back')}
        </Button>
      ) : null}
    </div>
  );
}

export default NotFoundState;
